import { z } from 'zod';
import { integerIdSchema, uuidSchema } from './primitives.js';
/** URL path / API field for a provisioned EFEM gateway (efem_clients.serial_number). */
export const gatewaySerialNumberParamSchema = z.string().min(1).max(255).trim();
export const EfemGatewaySerialParamSchema = z.object({
    gatewaySerialNumber: gatewaySerialNumberParamSchema,
});
export const TenantIdParamSchema = z.object({
    tenantId: uuidSchema,
});
export const ProviderEfemTenantGatewayParamSchema = TenantIdParamSchema.merge(EfemGatewaySerialParamSchema);
export const TempFingerprintIdParamsSchema = z.object({
    id: uuidSchema,
});
export const SessionIdParamsSchema = z.object({
    sessionId: uuidSchema,
});
export const WaferIdParamSchema = z.object({
    id: integerIdSchema,
});
export const WaferFingerprintWaferPathParamSchema = z.object({
    waferId: integerIdSchema,
});
export const WaferFingerprintImagePathParamSchema = z.object({
    waferId: integerIdSchema,
    imageId: z.string().min(1),
});
export const ContainerIdParamSchema = z.object({
    id: integerIdSchema,
});
export const GroupIdParamSchema = z.object({
    groupId: integerIdSchema,
});
export const DeviceSerialNumberParamSchema = z.object({
    serialNumber: z.string().min(1).max(64),
});
export const PackageIdParamSchema = z.object({
    packageId: uuidSchema,
});
export const StripeProductIdParamSchema = z.object({
    productId: z.string().min(1),
});
export const StripePriceIdParamSchema = z.object({
    priceId: z.string().min(1),
});
export const SubscriptionIdParamSchema = z.object({
    subscriptionId: uuidSchema,
});
export const EncryptionKeyIdParamSchema = z.object({
    keyId: uuidSchema,
});
//# sourceMappingURL=params.js.map